import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="py-20 bg-white" data-id="element-219">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-220">
        <FadeIn data-id="element-221">
          <div className="p-10 text-center bg-gradient-to-br from-[#0F2027] to-[#203A43] rounded-3xl shadow-2xl relative overflow-hidden" data-id="element-222">
            {/* Quote mark decoration */}
            <div className="absolute top-4 left-6 text-white/10 text-8xl font-serif leading-none" data-id="element-223">
              "
            </div>

            <h2 className="mb-6 text-2xl font-bold text-white md:text-3xl relative z-10" data-id="element-224">
              Resultados que puedes sentir
            </h2>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed relative z-10" data-id="element-225">
              En los primeros 7 días, notarás cómo tus manos y pies dejan de
              estar fríos{' '}
              <span className="text-amber-400" data-id="element-226">
                (señal de que tu metabolismo se ha encendido)
              </span>
              , tu energía por la tarde se estabiliza y la inflamación abdominal
              desaparece, permitiendo que tu ropa vuelva a quedarte como antes.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}